import { createFileRoute } from "@tanstack/react-router";
import WorkspaceGroupsPage from "@/components/settings/workspace/workspace-groups-page";

/** Legacy /settings/team/groups -> workspace team groups page. */
export const Route = createFileRoute("/_app/settings/team/groups/")({
	component: WorkspaceGroupsPage,
});
